import React, { useMemo } from 'react';
import _ from 'underscore';
import { ISiteMapNode, mapCurrentPageToPageGroup } from '@bingads-webui/search-utils';
import { useQuestionsFromQuery } from './use-questions-from-query';

export interface IWithQuestions {
  siteMap: ISiteMapNode[];
  Component: any;
  isTroubleshootingEnabled?: boolean,
  isReportingInsightsEnabled?: boolean,
}

export function withQuestions(props: IWithQuestions) {
  const {
    siteMap,
    Component,
    isTroubleshootingEnabled = false,
    isReportingInsightsEnabled = false,
  } = props;

  const query = useMemo(() => mapCurrentPageToPageGroup(siteMap), [siteMap]);
  const questions = useQuestionsFromQuery(query, { isTroubleshootingEnabled, isReportingInsightsEnabled });

  const rest = _.omit(props, 'Component');

  return (
    <Component
      {...rest}
      questions={questions}
    />
  );
}
